import qs from 'qs';
import React from 'react';
import Clipboard from 'clipboard';
import { Link } from 'styled-icons/boxicons-regular/Link';
import { Linkedin, Facebook, Twitter, Telegram } from 'styled-icons/boxicons-logos';

import { useStore } from '@src/models';
import { Modal, Flex, TextBox, StyledInput, Delimiter } from 'src/kit';
import Tooltip from 'src/components/Tooltip';
import { ShareButton } from '../atoms/ShareButton';

export const ShareJobModal = ({ shareLink, title, onClose, jobName }: any) => {
  const {
    userStore: { isFetching, user }
  } = useStore();

  const [showTooltip, setShowTooltip] = React.useState(false);

  const isLoginned = user && !isFetching;

  React.useEffect(() => {
    const clipboard = new Clipboard('#copy');
    clipboard.on('success', e => {
      setShowTooltip(true);
      e.clearSelection();
    });
  }, []);
  const shareLinkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${shareLink}&title=${encodeURIComponent(
    title
  )}`;
  const shareTwitterUrl = `https://twitter.com/intent/tweet?url=${shareLink}&text=${encodeURIComponent(title + ' - ')}`;
  const shareFacebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareLink}&quote=${encodeURIComponent(
    title
  )}`;
  const emailParams = {
    subject: title,
    body: shareLink
  };
  const mailToLink = `mailto:?${qs.stringify(
    emailParams
  )}?subject=Interesting job - ${jobName}&body=Hi,%20%3A%0D%0AI found this job you might be interested in - ${shareLink}%20%3A%0D%0ACheers,%20%3A%0D%0A${
    user?.first_name
  }"`;

  return (
    <Modal onClose={onClose} maxWidth={400} onClick={event => event.stopPropagation()}>
      <TextBox mb={30} color="textSecondary" fontSize={20} fontWeight="bold" textAlign="center">
        Share this job
      </TextBox>
      <Flex mb={40} justifyContent="center">
        <IconContainer as={ShareButton} href={shareLinkedinUrl} name="ShareOnLinkedin" bg="azure">
          <Linkedin size={30} />
        </IconContainer>
        <IconContainer as={ShareButton} href={shareFacebookUrl} name="ShareOnFacebook" bg="cerulean">
          <Facebook size={30} />
        </IconContainer>
        <IconContainer as={ShareButton} href={shareTwitterUrl} name="ShareOnTwitter" bg="dodgerBlue">
          <Twitter size={30} />
        </IconContainer>
        {isLoginned && (
          <IconContainer as="a" href={mailToLink} mr={0} bg="#1a305c">
            <Telegram size={30} />
          </IconContainer>
        )}
      </Flex>
      <Delimiter mb={30} mx={{ xs: -10, sm: -20, lg: -40 }} />
      <Flex>
        <StyledInput
          id="shareLink"
          value={shareLink}
          variant="ca"
          size="md"
          borderRadius={0}
          css={{ outline: 'none' }}
        />
        <Flex
          height={40}
          justifyContent="center"
          alignItems="center"
          p={10}
          color="coolGrey"
          css={{ position: 'relative', border: '1px solid #e4e4e4', borderWidth: '1px 1px 1px 0' }}
        >
          {showTooltip && <Tooltip>Copied!</Tooltip>}
          <Link
            role="button"
            id="copy"
            title="Copy to clipboard"
            data-clipboard-target="#shareLink"
            onMouseLeave={() => setShowTooltip(false)}
            size={20}
          />
        </Flex>
      </Flex>
    </Modal>
  );
};

const IconContainer = props => (
  <Flex mr={30} alignItems="center" justifyContent="center" width={40} height={40} color="white" {...props} />
);
